import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API, ENVIRONMENT } from 'src/app/_constants/app.constants';
import { ObjectLiteral } from 'src/app/_models/user';
import { LoggerService } from '../../ui/logger/logger.service';
import { SharedModule } from "src/app/_components/shared.module";
import { ServiceModule } from 'src/app/_services/service.module';
import { catchError, of } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: ServiceModule,
})
export class AirportsService {

  constructor(
    private http: HttpClient,
    private logger: LoggerService,
    private authService: AuthService,
  ) { }

  private _airports: ObjectLiteral[] = [];

  get airports(): ObjectLiteral[] {
    return this._airports
  }

  set airports(airports: ObjectLiteral[]) {
    this._airports = airports;
  }

  async getAirports(retryCount?: number) {
    retryCount = retryCount || 0;
    this.logger.debug('AirportService.getAirports()', arguments);
    let url = `${ENVIRONMENT.PROPERTIES.apiUrl}${API.AIRPORTS}/`;
    let body = {
      action: 'GET_AIRPORTS'
    };
    const headers = {
      'Hostname': this.authService.getHostName(),
      'Xsrf': this.authService.token
    };

    let response = await new Promise((res: any, rej: any) => {
      this.http.post(encodeURI(url), body, { headers: headers }).pipe(
        catchError(err => {
          return of({ success: false })
        })
      ).subscribe((data: any) => {
        res(data)
      })
    })

    // await this.http.post(encodeURI(url), body).toPromise().catch(e => e)

    if (response["success"]) {
      this.setAirports(response["data"])
    } else {
      if (retryCount == maxCalloutRetry) throw response;
    if (response["code"] == 403) {
      try {
        await this.authService.refreshToken();
        this.logger.debug('Flight service : searchFlightDetails() : Token refresh :: Success');
        return await this.getAirports(++retryCount);

      } catch (e) {
        this.logger.debug('Flight service : searchFlightDetails() : Exception thrown :: ', e.message);
        throw e;
      }
    } else throw response;
  }
  }

  setAirports(airports: ObjectLiteral) {
    this.logger.debug("Airport service :: setAirports()", airports);
    this.airports = airports.airportCodedetails;
  }

  filterAirports(toFilter: string, limit: number): ObjectLiteral[] {

    let filteredAirports = [];
    let airportsLength = this.airports.length

    // First search for airport codes
    for (let i = 0; i < airportsLength; i++) {
      this.airports[i].iataCode.toLowerCase().includes(toFilter.toLowerCase()) && (filteredAirports.push(this.airports[i]));
      if (filteredAirports.length == limit) break;
    }

    // Then look for matching airport names, if the max results has not found by now.
    if (filteredAirports.length !== limit) {
      for (let i = 0; i < airportsLength; i++) {
        this.airports[i].iataCode.toLowerCase() !== toFilter.toLowerCase() && this.airports[i].shortName.toLowerCase().includes(toFilter.toLowerCase()) && (filteredAirports.push(this.airports[i]));
        if (filteredAirports.length == limit) break;
      }
    }
    return filteredAirports;
  }
}
const maxCalloutRetry = 2